import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { CtaLink, PageHero, SectionHead } from "@/components/Ui";
import { InvestmentSnapshot } from "@/components/Blocks";
import { ProcessSteps } from "@/components/ProcessSteps";
import { TerritoryCta } from "@/components/CtaBands";

const ASKS = ["Preferred Market or State", "Investment Timeframe", "Available Liquid Capital", "Single- or Multi-Unit Interest", "Healthcare or physician background"];

export default function Process() {
  return (
    <>
      <Seo path="/process" />
      <PageHero eyebrow="The Franchise Process" title="Franchising Made Simple">
        <p>Five clear steps take you from your first inquiry to launching your own VidaVital Medical clinic.</p>
      </PageHero>

      <section className="section bg-ivory" aria-labelledby="steps-heading">
        <div className="wrap">
          <h2 id="steps-heading" className="sr-only">The five franchise process steps</h2>
          <ProcessSteps />
          <div className="mt-10"><CtaLink id="process-page-explore-franchise">Explore the Franchise</CtaLink></div>
        </div>
      </section>

      <section className="section bg-white" aria-labelledby="qualify-heading">
        <div className="wrap grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHead eyebrow="Qualification" title="What We’ll Ask You About" id="qualify-heading">
              <p>Step 1 begins with our discovery form. To prepare for your conversation with our team, it asks about:</p>
            </SectionHead>
          </div>
          <ul className="grid content-start gap-px bg-line sm:grid-cols-2 lg:col-span-7" data-testid="qualification-list">
            {ASKS.map((a) => <li key={a} className="bg-paper p-6 font-display font-semibold">{a}</li>)}
          </ul>
        </div>
      </section>

      <section className="section on-dark bg-ink text-ivory">
        <div className="wrap">
          <InvestmentSnapshot />
          <p className="mt-8 max-w-3xl text-stone-300">We will send you a copy of our Franchise Disclosure Document (FDD) at least 14 calendar days before you sign an agreement so that you can review the information thoroughly.</p>
          <Link to="/investment-support" className="text-link mt-6 inline-block" data-testid="process-investment-link">Review investment and support details</Link>
        </div>
      </section>

      <TerritoryCta />
    </>
  );
}
